import {NgModule} from '@angular/core';
import {UIReortComponent} from './ui-report.component';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {ReportService} from './report.service';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TimeStampConversionPipe} from './timestamp-conversion.pipe';
import 'rxjs' ;
import {UsersManagementComponent} from '../users-management/users-management.component';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forChild([
      {path: 'report', component: UIReortComponent},
      {path: 'user-management', component: UsersManagementComponent}
    ]),
    NgbModule,
  ],
  declarations: [
    UIReortComponent,
    UsersManagementComponent,
    TimeStampConversionPipe
  ],
  providers: [
    ReportService
  ],

})
export class FileTransferModule {
}
